var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: { label: "Dados do VTN: ", addMarginTop: false }
          }),
          _c(
            "div",
            { staticClass: "center position-relative" },
            [
              _vm.mostrarInfo
                ? _c("div", { staticClass: "info-percentual" }, [
                    _c("span", [
                      _vm._v(
                        "Atenção: O percentual a ser aplicado sobre o VTN é calculado automaticamente, manter vazio para ser calculado."
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Área requerida (ha):",
                          required: _vm.required
                        }
                      }),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Área",
                          precision: 4,
                          onkeypress: _vm.onlyInputNumbers,
                          hasValidationError: _vm.vtnRequest.areaRequerida === 0
                        },
                        on: { change: _vm.setModulosFiscais },
                        model: {
                          value: _vm.vtnRequest.areaRequerida,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "areaRequerida", $$v)
                          },
                          expression: "vtnRequest.areaRequerida"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isAmapa
                    ? _c(
                        "el-row",
                        { staticClass: "flexRow", attrs: { gutter: 16 } },
                        [
                          _c("app-label", {
                            staticClass: "appLabel",
                            attrs: {
                              label: "Munícipio:",
                              required: _vm.required
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "appInput" },
                            [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.setDados },
                                  model: {
                                    value: _vm.vtnRequest.municipio.id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest.municipio,
                                        "id",
                                        $$v
                                      )
                                    },
                                    expression: "vtnRequest.municipio.id"
                                  }
                                },
                                _vm._l(_vm.municipios, function(
                                  municipio,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index + "-" + municipio.id,
                                    attrs: {
                                      label: municipio.nome,
                                      value: municipio.id
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-row",
                        { staticClass: "flexRow", attrs: { gutter: 16 } },
                        [
                          _c("app-label", {
                            staticClass: "appLabel",
                            attrs: {
                              label: "Munícipio:",
                              required: _vm.required
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "el-input-group el-input-group--prepend appInput"
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.disable },
                                model: {
                                  value: _vm.vtnRequest.municipio.nome,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.vtnRequest.municipio,
                                      "nome",
                                      $$v
                                    )
                                  },
                                  expression: "vtnRequest.municipio.nome"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Número de Módulos fiscais:",
                          required: _vm.required
                        }
                      }),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Número de Módulos fiscais",
                          precision: 4,
                          onkeypress: _vm.onlyInputNumbers,
                          disable: _vm.disable
                        },
                        model: {
                          value: _vm.vtnRequest.nModuloFiscal,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "nModuloFiscal", $$v)
                          },
                          expression: "vtnRequest.nModuloFiscal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Módulo Fiscal do Múnicípio - MF (ha):",
                          required: _vm.required
                        }
                      }),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Módulo Fiscal do Múnicípio",
                          precision: 2,
                          onkeypress: _vm.onlyInputNumbers,
                          disable: _vm.disable
                        },
                        model: {
                          value: _vm.vtnRequest.moduloFiscal,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "moduloFiscal", $$v)
                          },
                          expression: "vtnRequest.moduloFiscal"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Valor mínimo da Pauta de VTN (PVTN):",
                          required: _vm.required
                        }
                      }),
                      _vm.vtnRequest.pvtn && _vm.vtnRequest.pvtn.vtnPorHaMin
                        ? _c("app-double-input", {
                            staticClass: "appInput",
                            attrs: {
                              name: "Valor mínimo da Pauta de VTN",
                              precision: 2,
                              prefix: "R$ ",
                              onkeypress: _vm.onlyInputNumbers,
                              disable: _vm.disable
                            },
                            model: {
                              value: _vm.vtnRequest.pvtn.vtnPorHaMinFormatado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vtnRequest.pvtn,
                                  "vtnPorHaMinFormatado",
                                  $$v
                                )
                              },
                              expression: "vtnRequest.pvtn.vtnPorHaMinFormatado"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c(
                        "div",
                        { staticClass: "appLabel flexRow" },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Percentual a ser aplicado sobre o VTN: ",
                              required: false
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "mr-5",
                              on: {
                                mouseover: function($event) {
                                  _vm.mostrarInfo = true
                                },
                                mouseleave: function($event) {
                                  _vm.mostrarInfo = false
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-info-circle" })]
                          )
                        ],
                        1
                      ),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Percentual a ser aplicado sobre o VTN",
                          hasValidationError:
                            _vm.vtnRequest.percentualCalculado > 100,
                          precision: 2,
                          onkeypress: _vm.onlyInputNumbers,
                          hasLimitValue: 6
                        },
                        model: {
                          value: _vm.vtnRequest.percentualCalculado,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "percentualCalculado", $$v)
                          },
                          expression: "vtnRequest.percentualCalculado"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75b55f64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b55f64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/InformarDados.vue
// module id = null
// module chunks = 